const intermediateObjectFieldNamesMap = new Map([
  ["DetailIdFieldName", "detailId"],
]);

export default intermediateObjectFieldNamesMap;
